export default [
  {
    path: "/copilot",
    name: "copilot",
    component: () => import("@/page/copilot/index.vue"),
    meta: {
      title: "copilot"
    },
    children: [
      {
        path: "/",
        name: "copilot-index",
        component: () => import("@/page/copilot/index/index.vue"),
        meta: { title: "小PAI Copilot" }
      },
      {
        path: "intelligent",
        name: "intelligent",
        component: () => import("@/page/copilot/intelligent/index.vue"),
        meta: { title: "智能问答" }
      },
      {
        path: "selectReport",
        name: "selectReport",
        component: () => import("@/page/copilot/selectReport/index.vue"),
        meta: { title: "选择研报" }
      },
      {
        path: "analysis",
        name: "analysis",
        component: () => import("@/page/copilot/analysis/index.vue"),
        meta: { title: "研报解析" }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/copilot.js